<template>
    <StocksList/>
</template>

<script>
import StocksList from '../../components/stocks/StocksList';

export default {
  components: {
    StocksList,
  },
};
</script>
